export default function canSchedule(store: {availableScheduleDaysOptions: any[]}) {
  const hasScheduleOrderOption =
    store && store.availableScheduleDaysOptions && store.availableScheduleDaysOptions.length > 0

  return hasScheduleOrderOption
}
